import { component } from "picoapp";
export default component((node, ctx) => {
  function handleSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const inputs = node.elements;
    const type = inputs["contact[inquiry_type]"].value;
    const orderNumber = inputs["contact[order_number]"].value;
    const user = theme.customer;
    const eventData = {
      "form - order number": orderNumber,
      "form - topic": type,
      "customer - logged in": user.isLoggedIn,
      "customer - shopify id": user.id,
      "customer - email": user.email ? user.email : "",
      "customer - total orders":
        user.orders_count || user.orders_count === 0 ? user.orders_count : "",
      "customer - total spent":
        user.total_spent || user.total_spent === 0
          ? (user.total_spent / 100).toFixed(2)
          : "",
    };

    window.maestro.fireTrackEvent("submitContactForm", eventData);
    node.submit();
  }
  node.addEventListener("submit", handleSubmit);
});
